import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker"
import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    editVisitors,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {

	}
    constructor(props) {
      
        super(props);
        this.state = {
            
            checkoutdate:new Date(this.props.data.checkoutdate), 
            checkindate:new Date(this.props.data.checkindate), 
            ssstartdate:new Date(this.props.data.ssstartdate), 
            ssenddate:new Date(this.props.data.ssenddate), 
            name:this.props.data.name, 
            mobile:this.props.data.mobile, 
            eid:this.props.data.eid, 
            
        };
    }

    selectdate = (date, val) => {      
        
        if(val==1){
            this.setState({ checkindate:date });
        }else if(val==2){
            this.setState({ checkoutdate:date });
        }else if(val==3){
            this.setState({ ssstartdate:date });
        }else if(val==4){
            this.setState({ ssenddate:date });
        }
        
        
   }       

    editHandleSubmit(event){
        event.preventDefault();
        this.props.editVisitors(event);
        
    }  


render() {

     
      return(
        <div>
             <div className="col-lg-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                            <RctCollapsibleCard heading="Edit visitor">   
                                    <div className="row">                                 
                                       
                                        <div className="col-sm-12 col-lg-6">
                                          <FormGroup>
                                             <Label for="Select">Name *</Label>
                                             <input type="text" name="name" id="name" defaultValue={this.state.name} className="form-control form-control-alternative" required />                                             
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6">
                                          <FormGroup>
                                             <Label for="Select">Mobile</Label>
                                             <input type="text" name="mobile" id="mobile" defaultValue={this.state.mobile} className="form-control form-control-alternative" />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Check-In Date *</Label>
                                                <DatePicker className="form-control" id="checkindate"  name="checkindate" autoComplete="off" required
                                                        selected={this.state.checkindate}
                                                        onChange={(date)=>this.selectdate(date,1)}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Check-Out Date *</Label>
                                                <DatePicker className="form-control" id="checkoutdate"  name="checkoutdate" autoComplete="off" required
                                                        selected={this.state.checkoutdate}
                                                        onChange={(date)=>this.selectdate(date,2)}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Session Start Date *</Label>
                                                <DatePicker className="form-control" id="startdate"  name="startdate" autoComplete="off" required
                                                        selected={this.state.ssstartdate}
                                                        onChange={(date)=>this.selectdate(date,3)}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Session End Date *</Label>
                                                <DatePicker className="form-control" id="enddate"  name="enddate" autoComplete="off" required
                                                        selected={this.state.ssenddate}
                                                        onChange={(date)=>this.selectdate(date,4)}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                        </div>                                       
                                        <div className="col-lg-12">
                                            <div className="form-group"> 
                                                <input type="hidden" name="eid" id="eid" value={this.state.eid}></input>
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" /> 
                                                <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>    
                                            </div>
                                        </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ visitors}) => {
    
   
}


export default connect(mapStateToProps, {
    
    editVisitors,
})(EditItems);
